import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import RestauranteHeader from '../components/restaurante/RestauranteHeader';
import SalonTabs from '../components/restaurante/SalonTabs';
import MesaCard from '../components/restaurante/MesaCard';
import useRestauranteSalones from '../hooks/restaurante/useRestauranteSalones';
import BarraOperador from '../components/restaurante/BarraOperador';
import AvisoRestaurante from '../components/restaurante/AvisoRestaurante';
import useOperadorRestaurante from '../hooks/restaurante/useOperadorRestaurante';

export default function Restaurante() {
  const restaurante = useRestauranteSalones();
  const navigate = useNavigate();
  const location = useLocation();
  const { operador, identificar } = useOperadorRestaurante();
  const [aviso, setAviso] = useState(location.state?.aviso || '');

  // El aviso viene de la mesa (por ejemplo, "cuenta cobrada"). Se limpia del
  // historial para que no reaparezca al recargar.
  useEffect(() => {
    if (location.state?.aviso) {
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location, navigate]);

  const mesas = restaurante.salonActivo?.mesas || [];
  const ocupadas = mesas.filter(
    (mesa) => mesa.estado === 'OCUPADA'
  ).length;

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <AvisoRestaurante
        mensaje={aviso}
        onCerrar={() => setAviso('')}
      />

      <main className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <div className="mb-4 flex justify-end">
          <BarraOperador
            operador={operador}
            onIdentificar={identificar}
          />
        </div>

        <RestauranteHeader
          totalMesas={mesas.length}
          ocupadas={ocupadas}
        />

        <div className="mt-6">
          <SalonTabs
            salones={restaurante.salones}
            salonActivoId={restaurante.salonActivoId}
            onChange={restaurante.setSalonActivoId}
          />
        </div>

        {restaurante.cargando && (
          <div className="mt-8 rounded-2xl border border-gray-200 bg-white p-10 text-center text-gray-500">
            Cargando salón...
          </div>
        )}

        {!restaurante.cargando && restaurante.error && (
          <div className="mt-8 rounded-2xl border border-red-200 bg-red-50 p-6 text-center">
            <p className="font-semibold text-red-700">
              {restaurante.error}
            </p>

            <button
              type="button"
              onClick={restaurante.recargar}
              className="mt-4 rounded-lg bg-azul-oscuro px-4 py-2 text-sm font-bold text-white"
            >
              Reintentar
            </button>
          </div>
        )}

        {!restaurante.cargando &&
          !restaurante.error &&
          restaurante.salones.length === 0 && (
            <div className="mt-8 rounded-2xl border border-dashed border-gray-300 bg-white p-10 text-center">
              <h2 className="text-lg font-bold text-azul-oscuro">
                No hay salones configurados
              </h2>

              <p className="mt-2 text-sm text-gray-500">
                Creá el primer salón para comenzar a organizar las mesas.
              </p>

              <Link
                to="/restaurante/configuracion"
                className="mt-5 inline-block rounded-lg bg-azul-oscuro px-4 py-2 text-sm font-bold text-white transition hover:bg-verde-oscuro"
              >
                Configurar salones
              </Link>
            </div>
          )}

        {!restaurante.cargando &&
          !restaurante.error &&
          restaurante.salonActivo && (
            <section className="mt-6">
              <div className="mb-4 flex items-end justify-between gap-4">
                <div>
                  <p className="text-xs font-bold uppercase tracking-wider text-verde-oscuro">
                    Salón
                  </p>

                  <h2 className="text-2xl font-extrabold text-azul-oscuro">
                    {restaurante.salonActivo.nombre}
                  </h2>
                </div>

                <div className="text-sm font-medium text-gray-500">
                  {mesas.length}{' '}
                  {mesas.length === 1 ? 'mesa' : 'mesas'}
                </div>
              </div>

              {mesas.length > 0 ? (
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                  {mesas.map((mesa) => (
                    <MesaCard
                      key={mesa.id}
                      mesa={mesa}
                      onClick={() =>
                        navigate(`/restaurante/mesa/${mesa.id}`)
                      }
                    />
                  ))}
                </div>
              ) : (
                <div className="rounded-2xl border border-dashed border-gray-300 bg-white p-10 text-center text-gray-500">
                  Este salón todavía no tiene mesas.
                </div>
              )}
            </section>
          )}
      </main>
    </div>
  );
}
